;(function () {
  const animateLines = (lines, delay = 0) => {
    lines.forEach((line, i) => {
      line.classList.add('animated')
      Array.from(line.children).forEach((element) => {
        element.style.animationDelay = `${delay + i * 0.25}s`
        setTimeout(() => {
          line.style.overflow = 'visible'
        }, delay * 1000 + i * 250 + 600)
      })
    })
  }

  const headingAnimation = () => {
    const slideshowTexts = document.querySelectorAll('.slideshow-slide__text--animation')
    const headings = document.querySelectorAll('.js-split-text')

    const splitHeadings = () => {
      if (document.querySelectorAll('.js-split-text').length > 0) {
        new SplitType(document.querySelectorAll('.js-split-text'))
        headings.forEach((heading) => heading.classList.add('visible'))
      }
    }

    const textObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const lines = entry.target.querySelectorAll('.js-split-text .line')
          if (entry.isIntersecting) {
            const speed = Number(entry.target.closest('.slideshow')?.dataset.speed || 0)
            let speedFade = speed
            if (lines && lines.length) {
              speedFade = speed * 1000 + lines.length * 250 + 100
              animateLines(lines, speed)
            }
            setTimeout(() => {
              entry.target.querySelectorAll('.js-fade').forEach((item) => item.classList.add('visible'))
            }, speedFade + 100)
          } else {
            lines.forEach((line) => {
              line.classList.remove('animated')
              line.style.overflow = 'hidden'
            })
            entry.target.querySelectorAll('.js-fade').forEach((item) => item.classList.remove('visible'))
          }
        })
      },
      { rootMargin: '0px 0px 0px 0px' }
    )

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const lines = entry.target.querySelectorAll('.js-split-text .line')
        if (lines && lines.length) {
          // re-split or animate if necessary
          splitHeadings(lines)
          animateLines(lines)
        }
        slideshowTexts.forEach((text) => textObserver.observe(text))
      })
    })

    splitHeadings()
    slideshowTexts.forEach((text) => {
      textObserver.observe(text)
      resizeObserver.observe(text)
    })
  }

  const slideshow = () => {
    document.querySelectorAll('.slideshow-section').forEach((section) => {
      if (section.classList.contains('slider_started')) return
      section.classList.add('slider_started')

      const id = section.id
      const box = section.querySelector('.slideshow')
      if (!box) return

      const autoplay = box.dataset.autoplay === 'true'
      const stopAutoplay = box.dataset.stopAutoplay === 'true'
      const delay = (Number(box.dataset.delay) || 0) * 1000
      const speed = (Number(box.dataset.speed) || 0) * 1000
      const effect = box.dataset.effect === 'custom' ? 'fade' : box.dataset.effect
      const isVideoBannerSlider = box.classList.contains('video-banner-slider')

      if (isVideoBannerSlider) {
        section.querySelectorAll('.video-banner-slider__video').forEach((video) => {
          video.muted = true
          video.defaultMuted = true
          video.playsInline = true
          video.setAttribute('muted', '')
          video.setAttribute('playsinline', '')
          video.setAttribute('autoplay', '')
          video.setAttribute('preload', 'auto')
        })
      }

      let autoplayParm = {}
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
            waitForTransition: true,
          },
        }
      }

      const swiperParms = {
        parallax: box.dataset.parallax === 'true',
        effect,
        virtualTranslate: effect === 'custom',
        watchSlidesProgress: true,
        speed,
        loop: isVideoBannerSlider,
        centeredSlides: false,
        autoHeight: false,
        calculateHeight: false,
        keyboard: true,
        fadeEffect: { crossFade: true },
        creativeEffect: {
          prev: { shadow: false, translate: [0, 0, -400] },
          next: { translate: ['100%', 0, 0] },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
          type: 'bullets',
        },
        ...autoplayParm,
        on: {
          init: function () {
            if (box.dataset.effect === 'custom') {
              const firstSlide = this.slides[0]
              if (firstSlide && firstSlide.classList.contains('swiper-slide-active')) {
                firstSlide.classList.add('no-animation')
              }
            }
          },
        },
      }

      // count slides z-index base
      let zIndex = section.querySelectorAll('.slideshow-swiper__slide').length
      const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms)

      const prevButton = section.querySelector('.video-banner-slider__arrow--prev')
      const nextButton = section.querySelector('.video-banner-slider__arrow--next')
      const playToggle = section.querySelector('.video-banner-slider__play-toggle')
      let userPausedActiveVideo = false

      const pagination = section.querySelector('.swiper-pagination');

      const totalSlides = section.querySelectorAll(
        '.slideshow-swiper__slide'
      ).length;

      const updatePaginationState = () => {
        if (!pagination) return;

        const lastIndex = swiper.pagination.bullets.length - 1;

        pagination.classList.toggle(
          'is-first-slide',
          swiper.realIndex === 0
        );

        pagination.classList.toggle(
          'is-last-slide',
          swiper.realIndex === lastIndex
        );
      };

      updatePaginationState();

      const visibleVideo = (slide) => {
        if (!slide) return null
        const videos = Array.from(slide.querySelectorAll('.video-banner-slider__video'))
        return videos.find((video) => window.getComputedStyle(video).display !== 'none') || videos[0] || null
      }

      const activeSlide = () => {
        return Array.from(swiper.slides).find((slide) => slide.classList.contains('swiper-slide-active')) || swiper.slides[swiper.activeIndex]
      }

      const isActiveVideo = (video) => video.closest('.swiper-slide')?.classList.contains('swiper-slide-active')

      const pauseInactiveVideos = () => {
        swiper.slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) return
          slide.querySelectorAll('.video-banner-slider__video').forEach((item) => item.pause())
        })
      }

      const syncVideoControl = () => {
        if (!playToggle) return;

        const slide = activeSlide();
        const hasVideo = slide?.dataset.hasVideo === 'true';
        const video = visibleVideo(slide);

        pauseInactiveVideos();

        if (!hasVideo || !video) {
          playToggle.hidden = true;
          return;
        }

        playToggle.hidden = false;
        playToggle.classList.toggle('is-paused', video.paused);
        playToggle.setAttribute(
          'aria-label',
          video.paused ? 'Play video' : 'Pause video'
        );
        playToggle.setAttribute(
          'aria-pressed',
          video.paused ? 'true' : 'false'
        );
      };

      const playActiveVideo = (retry = true) => {
        const video = visibleVideo(activeSlide())

        pauseInactiveVideos()

        if (!video) {
          syncVideoControl()
          return
        }

        if (userPausedActiveVideo) {
          syncVideoControl()
          return
        }

        video.muted = true
        video.defaultMuted = true
        video.playsInline = true
        video.setAttribute('muted', '')
        video.setAttribute('playsinline', '')
        video.setAttribute('autoplay', '')

        const playPromise = video.play()
        if (playPromise !== undefined) {
          playPromise.then(syncVideoControl).catch(() => {
            syncVideoControl()
            if (retry) {
              video.addEventListener('canplay', () => playActiveVideo(false), { once: true })
              video.addEventListener('loadeddata', () => playActiveVideo(false), { once: true })
            }
          })
        } else {
          syncVideoControl()
        }
      }

      if (prevButton) prevButton.addEventListener('click', () => swiper.slidePrev())
      if (nextButton) nextButton.addEventListener('click', () => swiper.slideNext())
      if (playToggle) {
        playToggle.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()

          const video = visibleVideo(activeSlide())
          if (!video) return

          if (video.paused) {
            userPausedActiveVideo = false
            const playPromise = video.play()
            if (playPromise !== undefined) {
              playPromise.then(syncVideoControl).catch(syncVideoControl)
            } else {
              syncVideoControl()
            }
          } else {
            userPausedActiveVideo = true
            video.pause()
            syncVideoControl()
          }
        })
        section.querySelectorAll('.video-banner-slider__video').forEach((video) => {
          video.muted = true
          video.defaultMuted = true
          video.playsInline = true
          video.setAttribute('muted', '')
          video.setAttribute('playsinline', '')
          video.setAttribute('autoplay', '')
          video.addEventListener('play', syncVideoControl)
          video.addEventListener('pause', () => {
            syncVideoControl()
            if (!userPausedActiveVideo && isActiveVideo(video)) {
              window.setTimeout(() => playActiveVideo(false), 50)
            }
          })
        })
        requestAnimationFrame(playActiveVideo)
        window.addEventListener('load', () => playActiveVideo(false), { once: true })
      }

      // pause on mouse enter for custom effect
      const swiperContainer = swiper.el.querySelector('.swiper-wrapper')
      if (box.dataset.effect === 'custom' && autoplay && stopAutoplay && swiperContainer) {
        swiperContainer.addEventListener('mouseenter', () => swiper.autoplay.stop())
        swiperContainer.addEventListener('mouseleave', () => swiper.autoplay.start())
      }

      swiper.on('transitionStart', function () {
        userPausedActiveVideo = false
        pauseInactiveVideos()
        if (box.dataset.effect === 'custom') {
          zIndex = zIndex + 1
          this.slides[this.activeIndex].style.setProperty('z-index', `${zIndex}`)
        }
      })

      swiper.on('transitionEnd', function () {
        playActiveVideo()
        // Remove text animation for other slides
        this.slides.forEach((slide, i) => {
          if (i !== this.activeIndex) {
            const headingSlide = slide.querySelector('.js-split-text')
            if (headingSlide) {
              const linesSlide = headingSlide.querySelectorAll('.line')
              linesSlide.forEach((line) => {
                line.classList.remove('animated')
                line.style.overflow = 'hidden'
              })
            }
            slide.querySelectorAll('.js-fade').forEach((item) => item.classList.remove('visible'))
          }
        })
      })

      // colorScheme helper - plain DOM
      function colorScheme(context) {
        // parent = box.find('.slideshow-bottom') -> box.querySelector
        const parent = box.querySelector('.slideshow-bottom')
        const activeIndex = context.activeIndex
        const activeSlide = context.slides[activeIndex]
        const changeItems = parent ? [parent] : []
        const slideEl = activeSlide ? activeSlide.querySelector('.slideshow-slide') : null
        const colorSchemeName = slideEl ? slideEl.dataset.colorScheme : undefined

        changeItems.forEach((item) => {
          if (!item) return
          // remove existing color-background-* classes
          Array.from(item.classList).forEach((className) => {
            if (/color-background-\d+$/.test(className)) item.classList.remove(className)
          })
          if (colorSchemeName) item.classList.add(colorSchemeName)
        })
      }

      swiper.on('beforeTransitionStart', function () {
        colorScheme(this)
      })

      swiper.on('slideChange', function () {
        updatePaginationState();
        userPausedActiveVideo = false
        // box.css('--bullet-duration', `${delay + speed}ms`)
        box.style.setProperty('--bullet-duration', `${delay + speed}ms`)
        colorScheme(this)
        requestAnimationFrame(playActiveVideo)

        if (box.dataset.effect === 'custom') {
          // Fix for first slide
          const firstSlide = this.slides[0]
          if (firstSlide) firstSlide.classList.remove('no-animation')

          // Fix autoplay for custom effect
          if (this.params.autoplay && this.params.autoplay.waitForTransition === true) {
            this.params.autoplay.delay = delay + speed
            this.params.autoplay.waitForTransition = false
            this.autoplay.stop()
            this.autoplay.start()
          }
        }
      })

      // Resize observer to compute --width-slide
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const container = entry.target.querySelector('.container')
          if (!container) return
          const style = window.getComputedStyle(container)
          const paddingLeft = parseFloat(style.paddingLeft) || 0
          const paddingRight = parseFloat(style.paddingRight) || 0
          const widthSlide = entry.contentRect.width - paddingLeft - paddingRight
          entry.target.style.setProperty('--width-slide', `${widthSlide}px`)
        })
      })

      // observe the section element (previously $(this)[0])
      resizeObserver.observe(section)
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    slideshow()
    headingAnimation()

    document.addEventListener('shopify:section:load', function () {
      slideshow()
      headingAnimation()
    })
  })
})()